<template lang="html"> 
<div>

  <div style="height:40px;"></div>
  
  <div class="bottom_nav_dev">
    <button v-for="(item,index) in buttons" :key="index" class="button_dev"
      @click="goLink(item.link)">
      {{item.title}}
    </button>
  </div>

</div>
</template>

<script>
export default {
  data () {
    return {
      buttons: [
        { link : '/', title: 'Home'},
        // { link : '/subscStatus', title: 'My BMW ServiceCare+'},
        { link : '/subscStatusVtg', title: 'ServiceCare+'},
        { link : '/subscRevoke', title: '서비스해지신청'},
      ],
    }
  },
  methods: {
    goLink(move) {
      this.$store.commit('unsetSubsc');
      if(this.$route.path != move) this.$router.push({path:move, query:{ vtg_id: this.$store.state.user.vtg_id}});
    }
  }
}
</script>

<style lang="css" scoped>
.bottom_nav_dev {
  height:40px;
  width:100%;
  position:fixed;
  bottom:0px;
  z-index: 2;
}
.button_dev {
  border: solid 1px #dddddd;
  width: calc(100% / 3); 
  height:100%; 
  padding:auto; 
  color:white; 
  font-weight:bold;
  background:black;
}
</style>
